module.exports = __webpack_public_path__ + "img/status-live.4225f855.svg";